/** Payment receipts / bank slips (Phase 107) — what the server accepts. */
export const RECEIPT_ACCEPT = '.pdf,.jpg,.jpeg,.png,application/pdf,image/jpeg,image/png';
export const MAX_RECEIPT_MB = 25;

const ALLOWED: Record<string, string[]> = {
  pdf: ['application/pdf'],
  jpg: ['image/jpeg'],
  jpeg: ['image/jpeg'],
  png: ['image/png'],
};

/** Why a file can't be used as a receipt, or null when it can. */
export const receiptFileProblem = (file: File): string | null => {
  const ext = file.name.split('.').pop()?.toLowerCase() ?? '';
  const types = ALLOWED[ext];
  if (!types || (file.type && !types.includes(file.type))) return `${file.name}: upload a PDF, JPG or PNG.`;
  if (file.size > MAX_RECEIPT_MB * 1024 * 1024) return `${file.name} is larger than ${MAX_RECEIPT_MB} MB.`;
  if (file.size === 0) return `${file.name} is empty.`;
  return null;
};

export const formatFileSize = (bytes: number) =>
  bytes >= 1024 * 1024 ? `${(bytes / (1024 * 1024)).toFixed(1)} MB` : `${Math.max(1, Math.round(bytes / 1024))} KB`;
